<mat-toolbar class="toolbar">
  @if (showToggle) {
  <button mat-icon-button (click)="toggleSidenav.emit()">
    <i-feather name="menu" class="header_icons"></i-feather>
  </button>
  }
  @if (showBranding) {
  <app-branding></app-branding>
  }
  <span class="flex-fill"></span>


  <!-- <button mat-button [matMenuTriggerFor]="hotelMenu" class="hotel-selector">
    <span>My Hotel</span>
    <mat-icon>expand_more</mat-icon>
  </button> -->
  <mat-menu #hotelMenu="matMenu">
    <button mat-menu-item>
      <mat-icon>business</mat-icon>
      <span>Grand Plaza</span>
    </button>
    <button mat-menu-item>
      <mat-icon>business</mat-icon>
      <span>Beach Paradise</span>
    </button>
    <button mat-menu-item>
      <mat-icon>business</mat-icon>
      <span>Ocean View</span>
    </button>
    <mat-divider></mat-divider>
    <button mat-menu-item>
      <mat-icon>add_circle</mat-icon>
      <span>Add New Hotel</span>
    </button>
  </mat-menu>

  <!-- <app-notification class="hide-small"></app-notification> -->
  <app-user></app-user>
</mat-toolbar>